import { render } from "./WatchlistCreator.vue?vue&type=template&id=23f91686&scoped=true"
import script from "./WatchlistCreator.vue?vue&type=script&lang=js"
export * from "./WatchlistCreator.vue?vue&type=script&lang=js"

import "./WatchlistCreator.vue?vue&type=style&index=0&id=23f91686&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f91686"]])

export default __exports__